function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { customElement as m } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { property as u } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { NgcInputText as h } from "../input-text/input-text.gator.js";
import "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/reactive-element.js";
import { html as d } from "../../../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/lit-html.js";
import "../../../../node_modules/.pnpm/lit-element@4.2.1/node_modules/lit-element/lit-element.js";
import p from "../../../../packages/web-components/src/components/input/gator/input-currency/input-currency.gator.scss.js";
import { str as y } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/internal/str-tag.js";
import { msg as c } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/install.js";
import { localized as f } from "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/internal/localized-decorator.js";
import "../../../../node_modules/.pnpm/@lit_localize@0.12.2/node_modules/@lit/localize/init/runtime.js";
import { unsafeCSS as v } from "../../../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/css-tag.js";
var g = Object.defineProperty,
  _ = Object.getOwnPropertyDescriptor,
  b = Object.getPrototypeOf,
  C = Reflect.get,
  o = function o(e, r, t, i) {
    for (var a = i > 1 ? void 0 : i ? _(r, t) : r, n = e.length - 1, l; n >= 0; n--) (l = e[n]) && (a = (i ? l(r, t, a) : l(a)) || a);
    return i && a && g(r, t, a), a;
  },
  D = function D(e, r, t) {
    return C(b(e), t, r);
  };
var s = /*#__PURE__*/function (_h) {
  function s() {
    var _this;
    _classCallCheck(this, s);
    _this = _callSuper(this, s, arguments), _this.value = "", _this._value = "", _this.type = "text", _this.currencyIsoCode = "USD";
    return _this;
  }
  _inherits(s, _h);
  return _createClass(s, [{
    key: "render",
    value: function render() {
      return d(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", "\n            <div id=\"ngc-input-currency-descriptor\">", "</div>\n        "])), _superPropGet(s, "render", this, 3)([]), this.currencyIsoCode);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      _superPropGet(s, "connectedCallback", this, 3)([]), this.startIcon = "", this._startIconAsText = this.currencySymbol, this._value = this.format(this.value), this._inputMode = "numeric", this._placeholder = this.placeholder || this.format("0"), this._ariaDescribedBy = "ngc-input-currency-descriptor";
    }
  }, {
    key: "updated",
    value: function updated(e) {
      if (_superPropGet(s, "updated", this, 3)([e]), e.has("value") && e.get("value") && (this._value = this.value), e.has("currencyIsoCode") && (this._startIconAsText = this.currencySymbol, this._placeholder = this.placeholder || this.format("0")), e.has("locale")) {
        var r = this.isPeriodAsDecimalCurrency ? "." : ",",
          t = this.isPeriodAsDecimalCurrency ? "," : ".";
        this._value && (this._value = this.format(this._value.replaceAll(t, r)));
        var i = new CustomEvent("change", {
          bubbles: !0,
          composed: !0,
          detail: {
            value: this._value
          }
        });
        this.dispatchEvent(i), this._placeholder = this.placeholder || this.format("0");
      }
      this.validateInput(this._value);
    }
  }, {
    key: "validateInput",
    value: function validateInput(e) {
      var _this$_value$match;
      if (/.*[^,\d.].*/.test(e)) return this._internalValidationError = c("Invalid input. Only numbers, commas or periods are allowed."), !1;
      var t = this.isPeriodAsDecimalCurrency ? "." : ",",
        i = ((_this$_value$match = this._value.match(new RegExp("\\" + t, "g"))) !== null && _this$_value$match !== void 0 ? _this$_value$match : []).length;
      if (!(this.numDecimalPlaces > 0) && i > 0) return this._internalValidationError = c("Invalid input. No decimals are allowed for this currency."), !1;
      if (i > 1) return this._internalValidationError = c("Invalid input. Only one decimal character is allowed."), !1;
      var n = new RegExp("^[\\d,]+\\.\\d{" + (this.numDecimalPlaces + 1) + ",}$"),
        l = new RegExp("^[\\d.]+,\\d{" + (this.numDecimalPlaces + 1) + ",}$");
      return (this.isPeriodAsDecimalCurrency ? n : l).test(e) ? (this._internalValidationError = c(y(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["Invalid input. Only ", " decimal places are allowed."])), this.numDecimalPlaces)), !1) : this._value === t ? (this._internalValidationError = c("Invalid input. Please enter a valid number value."), !1) : (this._internalValidationError = "", !0);
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var _this$inputRef$value, _r, _r2;
      if (this.displayedErrorText) return;
      var r = (_this$inputRef$value = this.inputRef.value) === null || _this$inputRef$value === void 0 ? void 0 : _this$inputRef$value.value.replaceAll(this.currencyThousandsSeparator, "");
      this.isPeriodAsDecimalCurrency || (r = (_r = r) === null || _r === void 0 ? void 0 : _r.replaceAll(",", "."));
      var t = this.format((_r2 = r) !== null && _r2 !== void 0 ? _r2 : "0.00"),
        i = new CustomEvent("change", {
          bubbles: !0,
          composed: !0,
          detail: {
            value: t
          }
        });
      this.dispatchEvent(i);
    }
  }, {
    key: "currencyNumberFormater",
    value: function currencyNumberFormater() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Intl.NumberFormat(this.locale || navigator.language, _objectSpread({
        style: "currency",
        currency: this.currencyIsoCode || "USD",
        currencyDisplay: "narrowSymbol"
      }, e));
    }
  }, {
    key: "format",
    value: function format(e) {
      return e ? this.currencyNumberFormater({
        useGrouping: !1
      }).format(parseFloat(e)).replaceAll(this.currencySymbol, "").trim() : "";
    }
  }, {
    key: "currencySymbol",
    get: function get() {
      var _this$currencyNumberF, _this$currencyNumberF2;
      return (_this$currencyNumberF = (_this$currencyNumberF2 = this.currencyNumberFormater({
        currencyDisplay: "narrowSymbol"
      }).formatToParts(1).find(function (e) {
        return e.type === "currency";
      })) === null || _this$currencyNumberF2 === void 0 ? void 0 : _this$currencyNumberF2.value) !== null && _this$currencyNumberF !== void 0 ? _this$currencyNumberF : "$";
    }
  }, {
    key: "currencyThousandsSeparator",
    get: function get() {
      var _this$currencyNumberF3, _this$currencyNumberF4;
      return (_this$currencyNumberF3 = (_this$currencyNumberF4 = this.currencyNumberFormater().formatToParts(1e3).find(function (e) {
        return e.type === "group";
      })) === null || _this$currencyNumberF4 === void 0 ? void 0 : _this$currencyNumberF4.value) !== null && _this$currencyNumberF3 !== void 0 ? _this$currencyNumberF3 : ",";
    }
  }, {
    key: "numDecimalPlaces",
    get: function get() {
      return (this.currencyNumberFormater().format(1).match(/0/g) || []).length;
    }
  }, {
    key: "isPeriodAsDecimalCurrency",
    get: function get() {
      return this.currencyThousandsSeparator === ",";
    }
  }]);
}(h);
s.styles = [].concat(_toConsumableArray(D(s, s, "styles")), [v(p)]);
o([u({
  attribute: "currency-iso-code"
})], s.prototype, "currencyIsoCode", 2);
o([u()], s.prototype, "locale", 2);
s = o([f(), m("ngc-input-currency")], s);
export { s as NgcInputCurrency };